import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { MetaMaskProvider } from "utils/metamask";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <MetaMaskProvider>
      <App />
    </MetaMaskProvider>
  </>
);

reportWebVitals();
